import { DELIVERY_TYPE_OPTIONS, enums } from "@shared/constants";
import { ShippingMethodsTypeMapIdType } from "@shared/constants/enums/enums-types";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";
import {
  t as utilsT,
  useTranslation,
} from "@shared/utils/internationalization";
import { Fragment } from "react";

export default function CheckoutDeliveryWithSelectionRequirement({
  groups,
  availableTicketDeliveryTypes,
  renderDeliveryMethodGroup,
  willCallLabel,
}: {
  groups: Array<{
    shippingTypes: ShippingMethodsTypeMapIdType[];
    itemGroups: TicketItemGroupType[];
  }>;
  availableTicketDeliveryTypes: ReadonlyArray<{
    id: string;
    label: string;
  }>;
  willCallLabel?: string;
  renderDeliveryMethodGroup: (
    {
      group,
      deliveryMethods,
      id,
    }: {
      group: {
        shippingTypes: ShippingMethodsTypeMapIdType[];
        itemGroups: TicketItemGroupType[];
      };
      deliveryMethods: ReadonlyArray<{ id: string; label: string }>;
      id: string;
    },
    index: number
  ) => React.ReactNode;
}) {
  const { t } = useTranslation("box-office");

  if (!groups.length) return null;

  return (
    <>
      {groups.map((group, index) => {
        const deliveryMethods = group.shippingTypes
          .map((type) => {
            if (type === enums.SHIPPING_METHODS.PRINT.id) {
              return (
                availableTicketDeliveryTypes
                  .map(({ id, label }) => ({
                    id,
                    label,
                  }))
                  // dont show none when delivery method selection is required
                  .filter(({ id }) => id !== DELIVERY_TYPE_OPTIONS.TYPE_NONE.id)
              );
            }

            return {
              id: type,
              label: getShippingTypesTabTranslations(
                type as ShippingMethodsTypeMapIdType,
                t,
                willCallLabel
              ),
            };
          })
          .flat();

        const id = group.shippingTypes.toString();

        return (
          <Fragment key={id}>
            {renderDeliveryMethodGroup({ group, deliveryMethods, id }, index)}
          </Fragment>
        );
      })}
    </>
  );
}

export function getShippingTypesTabTranslations(
  type: ShippingMethodsTypeMapIdType,
  t: typeof utilsT,
  willCallLabel?: string
): string {
  if (type === enums.SHIPPING_METHODS.PRINT.id) {
    return t("Email");
  }

  if (type === enums.SHIPPING_METHODS.WILL_CALL.id && willCallLabel) {
    return willCallLabel;
  }

  return enums.SHIPPING_METHODS_BY_ID[type].name;
}
